<template>
  <div
    class="profile-image-state"
    :title="title || null"
    :role="fallbackLabel ? 'img' : null"
    :aria-label="fallbackLabel || null"
  >
    <img
      v-if="showImage"
      v-bind="$attrs"
      class="profile-image-state__image"
      :src="src"
      :alt="alt"
      @error="imageFailed = true"
    >
    <span v-else-if="initials" class="profile-image-state__initials" aria-hidden="true">{{ initials }}</span>
    <span v-else class="material-icons profile-image-state__placeholder" aria-hidden="true">person</span>
  </div>
</template>

<script>
export default {
  name: 'ProfileImageState',
  inheritAttrs: false,
  props: {
    src: { type: String, default: '' },
    alt: { type: String, default: '' },
    name: { type: String, default: '' },
    fallbackText: { type: String, default: '' },
    title: { type: String, default: '' },
  },
  data() {
    return { imageFailed: false };
  },
  computed: {
    showImage() {
      return Boolean(this.src) && !this.imageFailed;
    },
    // The glyphs below are decorative, so without this the fallback reads as nothing at all.
    fallbackLabel() {
      return this.showImage ? '' : (this.alt || this.name || '');
    },
    initials() {
      if (this.fallbackText.trim()) return this.fallbackText.trim().slice(0, 2);

      const nameParts = this.name.trim().split(/\s+/).filter(Boolean);
      if (!nameParts.length) return '';

      const firstInitial = nameParts[0].charAt(0);
      const lastInitial = nameParts.length > 1 ? nameParts[nameParts.length - 1].charAt(0) : '';
      return `${firstInitial}${lastInitial}`.toUpperCase();
    },
  },
  watch: {
    src() {
      this.imageFailed = false;
    },
  },
};
</script>

<style scoped>
.profile-image-state {
  align-items: center;
  background: #f0f3f5;
  color: #8497a9;
  display: flex;
  /* The fallback glyphs are sized in em, so whatever sizes the box must set font-size to its
     height. This default is only a floor for a container that forgets. */
  font-size: 2.5rem;
  height: 100%;
  justify-content: center;
  overflow: hidden;
  width: 100%;
}
.profile-image-state__image { display: block; height: 100%; object-fit: cover; width: 100%; }
.profile-image-state__placeholder { font-size: .5em; }
.profile-image-state__initials { font-size: .34em; font-weight: 700; letter-spacing: .02em; text-transform: uppercase; }
.profile-image-state--large { font-size: 200px; min-height: 200px; width: 200px; }
.profile-image-state--circle { border-radius: 50%; }
.profile-image-state--compact { flex: 0 0 2rem; font-size: 2rem; height: 2rem; width: 2rem; }
</style>
